<template>
  <div>
    <!-- Header -->
    <HeaderComponent @login="onLogin" />

    <!-- Market View Content -->
    <main class="main-content">
      <div class="prediction-detail-wrapper" v-if="selectedPrediction">
        <div class="prediction-detail-content">
          <!-- Detailed Prediction Information -->
          <PredictionDetail :prediction="selectedPrediction" @vote="handleVote" />

          <!-- Percentage Change Chart -->
          <PercentageChart :finalPercentage="selectedPrediction.percentage" :predictionId="selectedPrediction.id" />

          <div class="market-description" >
            <h2>Условия выполнения</h2>
            <p :innerHTML="selectedPrediction.description"></p>
          </div> 
        </div>

        <!-- Card Actions -->
        <div class="card-actions-sticky">
          <TradeCard :prediction="selectedPrediction" :marketId="$props.id" :preSelectedChoice="selectedChoice" @amount-change="onAmountChange" />
        </div>
      </div>
      <div v-else class="no-prediction">
        <p>Loading prediction data...</p>
      </div>
    </main>
  </div>
</template>

<script>
import { ref, onMounted, watch } from 'vue';
import { useRoute } from 'vue-router';
import HeaderComponent from '../components/HeaderComponent.vue';
import PredictionDetail from '../components/PredictionDetail.vue';
import PercentageChart from '../components/PercentageChart.vue';
import TradeCard from '../components/TradeCard.vue';
import { apiClient } from '../api/client';

export default {
  name: 'MarketView',
  components: {
    HeaderComponent,
    PredictionDetail,
    PercentageChart,
    TradeCard
  },
  props: {
    id: {
      type: [String, Number], // Accept both string and number types
      default: null
    },
    selectedChoice: {
      type: [String],
      default: null
    },
  
  },
  setup(props) {
    const route = useRoute();
    const selectedPrediction = ref(props.selectedPrediction);
    const selectedChoice = ref(props.selectedChoice);
    const possiblePaymentAmount = ref(500);
   

    // Function to find prediction by ID
    const findPredictionById = async (id) => {
      let endpoint = `/markets/details/${id}`;
      if (possiblePaymentAmount.value !== null) {
        endpoint += `?possiblePaymentAmount=${possiblePaymentAmount.value}`;
      } else {
        endpoint += `?possiblePaymentAmount`;
      }
      const data = await apiClient.get(endpoint);
      console.log(data);
      selectedPrediction.value = data;
      return data;
    
    };

    // Initialize prediction based on route parameter
    onMounted(() => {
      if (props.id) {
        findPredictionById(props.id);
        console.log(selectedPrediction);
      } else {
        // Fallback to first prediction if no ID provided
        
      }
    });

    // Watch for changes in route parameter
    watch(
      () => route.params.id,
      (newId) => {
        if (newId) {
           findPredictionById(newId);
        }
      }
    );

    // Watch for changes in props
    watch(
      () => props.id,
      (newId) => {
        if (newId) {
          findPredictionById(newId);
        }
      }
    );

    const handleVote = (predictionId, vote) => {
      const prediction = selectedPrediction.value;
      if (prediction && prediction.id === predictionId) {
        console.log(`Voted ${vote}   on prediction:`, prediction.title);
        alert(`Вы проголосовали "${vote === 'yes' ? 'Да' : 'Нет'}" на прогноз: ${prediction.title}`);
      }
    };

    const onLogin = () => {
      // Page-specific login handling if needed
      console.log('Login event received in MarketView page');
    };

    const onAmountChange = (amount) => {
      possiblePaymentAmount.value = amount;
      // Refresh the prediction data with the new amount
      if (props.id) {
        findPredictionById(props.id);
      }
    };

    return {
      selectedPrediction,
      handleVote,
      onLogin,
      onAmountChange
    };
  }
};
</script>

<style scoped>
.main-content {
  /* padding: 1.5rem; */
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  flex-direction: row;
  gap: 1.5rem;
}

.prediction-detail-wrapper {
  display: flex;
  flex-direction: row;
  flex: 1;
  gap: 1.5rem;

}

.prediction-detail-content {
  /* flex: 1; */
  padding: 1.5em;
}

.card-actions-sticky {
  position: sticky;
  background: white;
  padding: 1rem;
  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.05);
  /* width: 370px; */
  display: flex;
  justify-content: center;
  top: 80px;
  height: fit-content;

  align-self: flex-start;
  /* Keeps div at top in flex layout */


}




h1 {
  color: #1f2937;
  margin-bottom: 1rem;
}

.no-prediction {
  text-align: center;
  padding: 2rem;
  color: #6b7280;
  font-size: 1.1rem;
}

.market-description {
  padding: 1.5rem 0;
}

.market-description h2 {
  color: #1f2937;
  margin-bottom: 1rem;
  font-size: 1.5rem;
  font-weight: 600;
}

.market-description p {
  margin-bottom: 1rem;
  line-height: 1.6;
  color: #374151;
}

.market-description p:last-child {
  margin-bottom: 0;
}

/* Media query for mobile view */
@media (max-width: 1024px) {
  .card-actions-sticky {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    width: 100%;
    z-index: 1000;
    padding: 0;
    background: white;
    box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);
    top: auto;
  }

  .prediction-detail-wrapper {
    flex-direction: column;
    padding-bottom: 160px;
    /* Add space at bottom to account for fixed card actions */
  }

  .main-content {
    flex-direction: column;
  }

  .prediction-detail-content {
    padding: 1.5em 1em;
  }
}
</style>